import { Injectable } from '@angular/core';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { Observable } from 'rxjs';
import { InspectionMeasureApiDto } from '../dto/inspection-measure.dto';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { HttpClient } from '@angular/common/http';
import {
  InspectionMeasureTool,
  InspectionMeasureType,
} from '../types/inspection-assembly-item';
import { InspectionMeasureRecord } from '../types/inspection-measure';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteInspectionMeasureService extends IApiBackendRouteService {
  urlRoute = `${API_BASE_URL}/inspection/measure`;

  constructor(protected readonly http: HttpClient) {
    super();
  }

  private createUrl(inspectionId: number): string {
    return `${API_BASE_URL}/inspection/${inspectionId}/measures`;
  }

  createRecord(
    inspectionId: number,
    body: InspectionMeasureApiDto['createRecord']['body']
  ): Observable<InspectionMeasureApiDto['createRecord']['response']> {
    return this.http.post<InspectionMeasureApiDto['createRecord']['response']>(
      `${this.createUrl(inspectionId)}`,
      body
    );
  }

  typesOfMeasure(departmentName?: string): Observable<InspectionMeasureType[]> {
    const query = departmentName ? `?department=${departmentName}` : '';
    return this.http.get<InspectionMeasureType[]>(`${this.urlRoute}/types${query}`);
  }

  addMeasureType(
    body: InspectionMeasureApiDto['addMeasureType']['body']
  ): Observable<InspectionMeasureType> {
    return this.http.post<InspectionMeasureType>(
      `${this.urlRoute}/types`,
      body
    );
  }

  finishPartial(
    inspectionId: number,
    body?: InspectionMeasureApiDto['finishPartial']['body']
  ): Observable<any> {
    return this.http.post(`${this.urlRoute}/${inspectionId}/finish`, {
      ...body,
    });
  }

  deleteNewest(inspectionId: number): Observable<InspectionMeasureRecord> {
    return this.http.delete<InspectionMeasureRecord>(
      `${this.urlRoute}/${inspectionId}/newest-record`
    );
  }

  getTools(): Observable<InspectionMeasureTool[]> {
    return this.http.get<InspectionMeasureTool[]>(`${this.urlRoute}/tools`);
  }
}
